import userInfo from 'hub-http/userInfo';
import PortalIdParser from 'PortalIdParser';
import { logRavenException } from 'ui-deal-management-components-lib/utils/ravenWrapperUtil';
import { INITIALIZE_AUTH } from './ActionTypes';
import { setInitialFilters } from './FiltersActions';
import { fetchForecastTypes, fetchPipelines } from './ForecastActions';
import { fetchPortalSettings } from './PortalSettingsActions';
import { getIsUngatedToForecastingMultipleOutcomes } from '../selectors/authSelectors';
import { setupData } from '../utils/initGeneralStore';
export function getAuth() {
  return function (dispatch, getState) {
    PortalIdParser.get();
    return userInfo().then(auth => {
      setupData(auth);
      return auth;
    }).then(({
      user,
      gates,
      portal
    }) => {
      const authAction = {
        type: INITIALIZE_AUTH,
        user,
        gates,
        portal
      };
      dispatch(authAction);
      const team = user.teams.find(_team => _team.my_team);
      const value = team && team.id ? [`${team.id}`] : [];
      const state = getState();
      const isUngatedToForecastingMultipleOutcomes = getIsUngatedToForecastingMultipleOutcomes(state);

      // setInitialFilters relies on pipelines being fetched to validate
      // pipelines passed in by query params
      return Promise.all([dispatch(fetchPipelines()), isUngatedToForecastingMultipleOutcomes && dispatch(fetchForecastTypes()).catch(() => {
        // should be caught in fetchForecastTypes
      }), dispatch(fetchPortalSettings())]).then(() => {
        dispatch(setInitialFilters(value));
      }).then(() => {
        return authAction;
      }).catch(error => {
        logRavenException(error, 'Auth fetch');
        return authAction;
      });
    });
  };
}